<template>
	<span class="result-counter">{{ counter }} results</span>
</template>

<script>
export default {
	name: 'ResultCounter',
	props: {
		counter: {
			type: [String, Number],
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.result-counter {
	font-size: $result-counter-font-size;
	color: $result-counter-color;
}
</style>
